// import external dependencies
import 'jquery';

// Import Partials

/* stylelint-disable */
import './partials/aos-init.js'; import './partials/cookies-alert-core.js'; import './partials/cookies-alert-script.js'; import './partials/fontawesome-embed.js'; import './partials/index.js'; import './partials/jarallax.js'; import './partials/navbar-dropdown.js'; import './partials/script.js'; import './partials/smooth-scroll.js'; import './partials/swiper-init.js'
/* stylelint-enable */


// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/main.js